import { Skeleton, Stack } from "@mui/material";
import React from "react";
import { SalespersonActivityStats } from "../../../store/services/salesManagerService";
import SalespersonTable from "../salespeople/SalespersonTable";

interface SalespeopleTabProps {
  salespersonStats: SalespersonActivityStats[] | undefined;
  isLoading: boolean;
  onRowClick: (stats: SalespersonActivityStats) => void;
}

const SalespeopleTab: React.FC<SalespeopleTabProps> = ({
  salespersonStats,
  isLoading,
  onRowClick,
}) => {
  if (isLoading) {
    return (
      <Stack spacing={1}>
        {[...Array(6)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            height={64}
            sx={{ borderRadius: 2 }}
          />
        ))}
      </Stack>
    );
  }

  return (
    <SalespersonTable
      data={salespersonStats ?? []}
      onRowClick={onRowClick}
    />
  );
};

export default SalespeopleTab;
